<div class="notifications-bell-wrap">
  <button
    type="button"
    mat-icon-button
    class="notifications-bell-btn"
    (click)="togglePanel()"
    aria-label="Notifications"
    [attr.aria-expanded]="panelOpen"
  >
    <i-tabler name="bell" class="icon-20 d-flex"></i-tabler>
    <span class="notifications-bell-badge" *ngIf="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
  </button>

  <button
    type="button"
    class="notifications-bell-backdrop"
    *ngIf="panelOpen"
    (click)="closePanel()"
    aria-label="Close notifications"
  ></button>

  <div class="notifications-bell-panel" *ngIf="panelOpen" (click)="$event.stopPropagation()">
    <div class="notifications-bell-panel-head">
      <span class="notifications-bell-panel-title">Notifications</span>
    </div>

    <div class="notifications-bell-loading" *ngIf="loading">
      <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
    </div>

    <div class="notifications-bell-empty" *ngIf="!loading && !items.length">
      No new notifications.
    </div>

    <div class="notifications-bell-list" *ngIf="!loading && items.length">
      <div
        class="notifications-bell-item notifications-bell-item--unread"
        *ngFor="let item of items; trackBy: trackById"
        role="button"
        tabindex="0"
        (click)="onItemClick(item)"
        (keydown.enter)="onItemClick(item)"
        (keydown.space)="onItemClick(item); $event.preventDefault()"
      >
        <div class="notifications-bell-item-content">
          <div class="notifications-bell-item-title">{{ item.title }}</div>
          <div
            class="notifications-bell-item-meta"
            *ngIf="item.brand_name || item.actor_name"
          >
            <span class="notifications-bell-item-brand" *ngIf="item.brand_name">{{ item.brand_name }}</span>
            <span class="notifications-bell-item-meta-sep" *ngIf="item.brand_name && item.actor_name"> · </span>
            <span class="notifications-bell-item-actor" *ngIf="item.actor_name">{{ item.actor_name }}</span>
          </div>
          <div class="notifications-bell-item-body" *ngIf="item.body">{{ item.body }}</div>
          <div class="notifications-bell-item-time">{{ item.created_at | date: 'dd/MM/yyyy HH:mm' }}</div>
        </div>
        <button
          type="button"
          class="notifications-bell-item-dismiss"
          aria-label="Dismiss notification"
          [matTooltip]="'Dismiss for me only'"
          (click)="dismissOne($event, item)"
        >
          <i-tabler name="x" class="icon-14 d-flex"></i-tabler>
        </button>
      </div>
    </div>

    <div class="notifications-bell-footer" *ngIf="!loading && items.length && hasMore">
      <button
        type="button"
        mat-stroked-button
        class="notifications-bell-load-more"
        [disabled]="loadingMore"
        (click)="loadMore($event)"
      >
        {{ loadingMore ? 'Loading…' : 'Load more' }}
      </button>
    </div>
  </div>
</div>
